import React, { useId, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type RangeSliderProps = {
  label: string;
  unit: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (v: number) => void;
  /** Delay (s) for the "drag me" hint so stacked sliders don't move in unison. */
  hintDelay?: number;
};
export function RangeSlider({
  label,
  unit,
  min,
  max,
  step = 1,
  value,
  onChange,
  hintDelay = 0
}: RangeSliderProps) {
  const id = useId();
  const [touched, setTouched] = useState(false);
  const pct = (value - min) / (max - min) * 100;
  return <div data-id="element-211" data-mp="1w6xlibctuo4o">
      <div className="flex items-baseline justify-between" data-id="element-212" data-mp="1w533p5wurc4t">
        <label htmlFor={id} className="font-mono text-[10.5px] tracking-[0.14em] text-graphite" data-id="element-213" data-mp="207ptz2dvkozw">
          {label}
        </label>
        <p className="text-[20px] font-semibold tabular-nums tracking-[-0.02em] text-ink" data-id="element-214" data-mp="2nw965t01plx9">
          {value}
          <span className="ml-1 text-[12px] font-medium text-graphite" data-id="element-215" data-mp="2sotxmnvhbmxm">{unit}</span>
        </p>
      </div>
      <div className="relative mt-1 h-9" data-id="element-216" data-mp="11gxvjkltxqu1">
        <div className="absolute inset-x-0 top-1/2 h-[4px] -translate-y-1/2 rounded-full bg-ink/10" data-id="element-217" data-mp="wh38js56dle9" />
        <div className="absolute left-0 top-1/2 h-[4px] -translate-y-1/2 rounded-full bg-ink" style={{
        width: `${pct}%`
      }} data-id="element-218" data-mp="1b5zdhgbxqian" />
        <div className="pointer-events-none absolute top-1/2 -translate-x-1/2 -translate-y-1/2" style={{
        left: `${pct}%`
      }} aria-hidden="true" data-id="element-219" data-mp="16ezfs8uzrw73">
          <div className={touched ? '' : 'snak-drag'} style={touched ? undefined : {
          animationDelay: `${hintDelay}s`
        }} data-id="element-220" data-mp="1g5c84n91stns">
            <div className="relative flex items-center" data-id="element-221" data-mp="1u3sgeimk6s81">
              {!touched && <ChevronLeftIcon size={14} strokeWidth={2.5} className="absolute -left-4 text-accent" data-id="element-222" data-mp="1p60dyuoafnpl" />}
              <span className={`block h-6 w-6 rounded-full border-2 bg-white shadow-[0_2px_6px_rgba(28,29,34,0.18)] ${touched ? 'border-ink' : 'snak-ring border-accent'}`} style={touched ? undefined : {
              animationDelay: `${hintDelay}s`
            }} data-id="element-223" data-mp="3vvyfl96atx5c" />
              {!touched && <ChevronRightIcon size={14} strokeWidth={2.5} className="absolute -right-4 text-accent" data-id="element-224" data-mp="1ztv2q7zeylhs" />}
            </div>
          </div>
        </div>
        <input id={id} type="range" min={min} max={max} step={step} value={value} onChange={e => {
        setTouched(true);
        onChange(Number(e.target.value));
      }} onPointerDown={() => setTouched(true)} className="precision-range absolute inset-0 h-full w-full cursor-pointer" aria-valuetext={`${value} ${unit}`} data-id="element-225" data-mp="28tqiyr7tt6oo" />
      </div>
      <div className="flex justify-between font-mono text-[9.5px] text-graphite/70" aria-hidden="true" data-id="element-226" data-mp="2rjq6h9o0qdpz">
        <span data-id="element-227" data-mp="2wl5qqzidgg7b">{min}</span>
        <span data-id="element-228" data-mp="2whhw1x16xnr0">{max}</span>
      </div>
    </div>;
}